export default __webpack_public_path__ + "media/images/landing-37-550x420-844579920400f244c61df574b1828508.jpg";